import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { useT } from "@/lib/i18n";
import ExportButton from "@/components/ExportButton";

export default function SubscriberAnimals() {
  const { t } = useT();
  const [animals, setAnimals] = useState([]);
  useEffect(() => { api.get("/subscriber/animals").then((r) => setAnimals(r.data)); }, []);

  const STATUS_COLOR = {
    in_haat: "bg-accent text-accent-foreground",
    sold: "bg-primary text-primary-foreground",
    exited_unsold: "bg-muted text-muted-foreground",
    registered: "bg-accent text-accent-foreground",
  };

  return (
    <DashboardShell
      title={t("nav.animals")}
      subtitle={`${animals.length} ${t("sub.animalsCount")}`}
      action={
        <ExportButton
          basePath="/subscriber/export/animals"
          baseFilename="animals"
          testId="export-animals-btn"
        />
      }
    >
      <div className="am-card p-2 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-muted-foreground border-b">
              <th className="px-4 py-3">{t("sub.regNo")}</th>
              <th className="px-4 py-3">{t("sub.type")}</th>
              <th className="px-4 py-3">{t("sub.breed")}</th>
              <th className="px-4 py-3">{t("sub.gender")}</th>
              <th className="px-4 py-3">{t("sub.weight")}</th>
              <th className="px-4 py-3">{t("sub.vehicle")}</th>
              <th className="px-4 py-3">{t("common.status")}</th>
            </tr>
          </thead>
          <tbody>
            {animals.map((a) => (
              <tr key={a.animal_id} className="border-b last:border-0">
                <td className="px-4 py-3 font-mono">{a.registration_number}</td>
                <td className="px-4 py-3 capitalize">{a.animal_type}</td>
                <td className="px-4 py-3">{a.breed || "—"}</td>
                <td className="px-4 py-3 capitalize">{a.gender}</td>
                <td className="px-4 py-3 font-mono">{a.weight_kg} kg</td>
                <td className="px-4 py-3 font-mono">{a.vehicle_number || "—"}</td>
                <td className="px-4 py-3"><span className={`am-chip ${STATUS_COLOR[a.status] || ""}`}>{a.status.replace("_", " ")}</span></td>
              </tr>
            ))}
            {animals.length === 0 && <tr><td colSpan={7} className="py-12 text-center text-muted-foreground">{t("sub.noAnimals")}</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
